import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCoffeeCount, incrementCoffee } from '../services/api';
import LanguageSwitcher from '../components/LanguageSwitcher';
import '../styles/Home.css';

const Home = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [coffeeCount, setCoffeeCount] = useState(0);
  const [showCoffeeAnimation, setShowCoffeeAnimation] = useState(false);
  const [isLoadingCoffee, setIsLoadingCoffee] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    // Charger le compteur de cafés depuis l'API
    loadCoffeeCount();
  }, []);

  const loadCoffeeCount = async () => {
    const result = await getCoffeeCount();
    if (result.success) {
      setCoffeeCount(result.count);
    }
  };

  

  const handleCoffeeClick = async () => {
    if (isLoadingCoffee) return;
    
    setIsLoadingCoffee(true);
    
    // Animation immédiate pour le feedback utilisateur
    setShowCoffeeAnimation(true);
    setTimeout(() => setShowCoffeeAnimation(false), 1000);
    
    // Incrémenter via l'API
    const result = await incrementCoffee();
    
    if (result.success) {
      setCoffeeCount(result.count);
    }
    
    setIsLoadingCoffee(false);
  };

  const technologies = [
    { name: 'React', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
    { name: 'React Native', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg' },
    { name: 'Node.js', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg' },
    { name: 'MongoDB', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg' },
    { name: 'JavaScript', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg' }
  ];

  const advantages = [
    {
      icon: t('home.advantages.price.icon'),
      title: t('home.advantages.price.title'),
      description: t('home.advantages.price.desc')
    },
    {
      icon: t('home.advantages.speed.icon'),
      title: t('home.advantages.speed.title'),
      description: t('home.advantages.speed.desc')
    },
    {
      icon: t('home.advantages.support.icon'),
      title: t('home.advantages.support.title'),
      description: t('home.advantages.support.desc')
    },
    {
      icon: t('home.advantages.quality.icon'),
      title: t('home.advantages.quality.title'),
      description: t('home.advantages.quality.desc')
    }
  ];

  return (
    <div className="home-container">
      {/* <LanguageSwitcher /> */}
      
      {/* Hero Section */}
      <section className={`hero-section ${isVisible ? 'visible' : ''}`}>
   
              {/* Fond étoilé animé */}
        <div className="stars-background">
          <div id="stars"></div>
          <div id="stars2"></div>
          <div id="stars3"></div>
        </div>

        <div className="hero-content">
          {/* Logo DreamDev */}
          <div className="dreamdev-logo-container">
            <img 
              src={require('../assets/Logo.png')} 
              alt="DreamDev Logo" 
              className="dreamdev-logo"
            />
           <p className="dreamdev-slogan">
  Where your digital dreams come {"{true};"}
</p>

          </div>

          <div className="hero-cta-buttons">
            <Link to="/contact-client" className="cta-button cta-client">
              <span className="cta-icon">{t('home.cta.client.icon')}</span>
              <div className="cta-text">
                <span className="cta-title">{t('home.cta.client.title')}</span>
              </div>
              <span className="cta-arrow">→</span>
            </Link>

            <Link to="/contact-entreprise" className="cta-button cta-entreprise">
              <span className="cta-icon">{t('home.cta.entreprise.icon')}</span>
              <div className="cta-text">
                <span className="cta-title">{t('home.cta.entreprise.title')}</span>
              </div>
              <span className="cta-arrow">→</span>
            </Link>
          </div>

          {/* Bouton café interactif */}
          {/* <div className="coffee-section">
            <button 
              className={`coffee-button ${isLoadingCoffee ? 'loading' : ''}`}
              onClick={handleCoffeeClick}
              disabled={isLoadingCoffee}
            >
              <span className="coffee-emoji">☕</span>
              <span className="coffee-text">{t('home.coffee.button') || 'M\'offrir un café'}</span>
              {showCoffeeAnimation && (
                <span className="coffee-animation">+1</span>
              )}
            </button>
            {coffeeCount > 0 && (
              <p className="coffee-counter">
                <span className="counter-emoji">🎉</span>
                {coffeeCount} {coffeeCount === 1 ? 'café offert' : 'cafés offerts'} - Merci !
              </p>
            )}
          </div> */}
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="section-content">
          <span className="section-tag">{t('home.about.tag')}</span>
          <h2 className="section-title">{t('home.about.title')}</h2>
          <p className="section-description">
            {t('home.about.p1')}
          </p>
          <p className="section-description">
            {t('home.about.p2')}
          </p>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="tech-section">
        <div className="section-content">
          <span className="section-tag">{t('home.tech.tag')}</span>
          <h2 className="section-title">{t('home.tech.title')}</h2>
          
          <div className="tech-grid">
            {technologies.map((tech, index) => (
              <div 
                key={tech.name} 
                className="tech-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <img src={tech.icon} alt={tech.name} className="tech-icon" />
                <span className="tech-name">{tech.name}</span>
              </div>
            ))}
          </div>

          <div className="tech-details">
            <div className="tech-category">
              <h3>{t('home.tech.web.title')}</h3>
              <p>{t('home.tech.web.desc')}</p>
            </div>
            <div className="tech-category">
              <h3>{t('home.tech.mobile.title')}</h3>
              <p>{t('home.tech.mobile.desc')}</p>
            </div>
            <div className="tech-category">
              <h3>{t('home.tech.backend.title')}</h3>
              <p>{t('home.tech.backend.desc')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="advantages-section">
        <div className="section-content">
          <span className="section-tag">{t('home.advantages.tag')}</span>
          <h2 className="section-title">{t('home.advantages.title')}</h2>
          
          <div className="advantages-grid">
            {advantages.map((advantage, index) => (
              <div 
                key={advantage.title} 
                className="advantage-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="advantage-icon">{advantage.icon}</div>
                <h3 className="advantage-title">{advantage.title}</h3>
                <p className="advantage-description">{advantage.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="section-content">
          <span className="section-tag">{t('home.testimonials.tag') || '💬 Témoignages'}</span>
          <h2 className="section-title">{t('home.testimonials.title') || 'Ce que disent mes clients'}</h2>
          <p className="section-description">
            {t('home.testimonials.subtitle') || 'Retours d\'expérience de clients satisfaits'}
          </p>

          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <span className="avatar-letter">M</span>
                </div>
                <div className="testimonial-author">
                  <h4>{t('home.testimonials.client1.name') || 'Marie D.'}</h4>
                  <p className="testimonial-role">{t('home.testimonials.client1.role') || 'Fondatrice Startup E-commerce'}</p>
                </div>
              </div>
              <div className="testimonial-rating">
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
              </div>
              <p className="testimonial-text">
                {t('home.testimonials.client1.text') || 
                  '"Ibra a développé notre site e-commerce de A à Z. Professionnel, réactif et à l\'écoute. Le résultat dépasse nos attentes ! Notre chiffre d\'affaires a augmenté de 40% grâce à la nouvelle plateforme."'}
              </p>
              <span className="testimonial-project">📦 {t('home.testimonials.client1.project') || 'Projet: Site E-commerce'}</span>
            </div>

            <div className="testimonial-card featured">
              <div className="featured-badge">⭐ Top Review</div>
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <span className="avatar-letter">T</span>
                </div>
                <div className="testimonial-author">
                  <h4>{t('home.testimonials.client2.name') || 'Thomas L.'}</h4>
                  <p className="testimonial-role">{t('home.testimonials.client2.role') || 'CEO Tech Agency'}</p>
                </div>
              </div>
              <div className="testimonial-rating">
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
              </div>
              <p className="testimonial-text">
                {t('home.testimonials.client2.text') || 
                  '"Application mobile développée en React Native pour notre startup. Code propre, performances excellentes et respect des délais. Je recommande à 100% et je referai appel à ses services sans hésiter!"'}
              </p>
              <span className="testimonial-project">📱 {t('home.testimonials.client2.project') || 'Projet: App Mobile Fitness'}</span>
            </div>

            <div className="testimonial-card">
              <div className="testimonial-header">
                <div className="testimonial-avatar">
                  <span className="avatar-letter">S</span>
                </div>
                <div className="testimonial-author">
                  <h4>{t('home.testimonials.client3.name') || 'Sarah B.'}</h4>
                  <p className="testimonial-role">{t('home.testimonials.client3.role') || 'Directrice Marketing'}</p>
                </div>
              </div>
              <div className="testimonial-rating">
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
                <span className="star">⭐</span>
              </div>
              <p className="testimonial-text">
                {t('home.testimonials.client3.text') || 
                  '"Refonte complète de notre site web avec un design moderne et responsive. Ibra a su comprendre nos besoins et proposer des solutions créatives. Le site charge super rapidement et le SEO s\'est amélioré!"'}
              </p>
              <span className="testimonial-project">🌐 {t('home.testimonials.client3.project') || 'Projet: Refonte Site Web'}</span>
            </div>
          </div>

          <div className="testimonials-stats">
            <div className="stat-item">
              <span className="stat-number">98%</span>
              <span className="stat-label">{t('home.testimonials.satisfaction') || 'Satisfaction client'}</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">20+</span>
              <span className="stat-label">{t('home.testimonials.projects') || 'Projets livrés'}</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">5/5</span>
              <span className="stat-label">{t('home.testimonials.rating') || 'Note moyenne'}</span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="final-cta-section">
        <div className="section-content">
          <h2 className="cta-section-title">{t('home.final.title')}</h2>
          <p className="cta-section-description">
            {t('home.final.description')}
          </p>

          <div className="final-cta-cards">
            <div className="final-cta-card client-card" id="client">
              <div className="card-header">
                <span className="card-emoji">{t('home.card.client.emoji')}</span>
                <h3>{t('home.card.client.title')}</h3>
              </div>
              <p className="card-description">
                {t('home.card.client.desc')}
              </p>
              <ul className="card-features">
                <li>{t('home.card.client.feature1')}</li>
                <li>{t('home.card.client.feature2')}</li>
                <li>{t('home.card.client.feature3')}</li>
                <li>{t('home.card.client.feature4')}</li>
              </ul>
              <Link to="/contact-client" className="card-button client-button">
                {t('home.card.client.button')}
                <span className="button-arrow">→</span>
              </Link>
            </div>

            <div className="final-cta-card entreprise-card" id="entreprise">
              <div className="card-header">
                <span className="card-emoji">{t('home.card.entreprise.emoji')}</span>
                <h3>{t('home.card.entreprise.title')}</h3>
              </div>
              <p className="card-description">
                {t('home.card.entreprise.desc')}
              </p>
              <ul className="card-features">
                <li>{t('home.card.entreprise.feature1')}</li>
                <li>{t('home.card.entreprise.feature2')}</li>
                <li>{t('home.card.entreprise.feature3')}</li>
                <li>{t('home.card.entreprise.feature4')}</li>
              </ul>
              <Link to="/contact-entreprise" className="card-button entreprise-button">
                {t('home.card.entreprise.button')}
                <span className="button-arrow">→</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home;